export default __webpack_public_path__ + "static/media/right-arrow.3198352b.svg";